import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import useScreenOrientationExtended from "../hooks/useScreenOrientationExtended";
import classNames from "classnames";
import AppContext from "../store";
import useDeviceSizeDetect from "../hooks/useDeviceSizeDetect";

export default function MainLayout({children}) {
  const {isConfiguratorAvailable} = useContext(AppContext);
  const { className: orientationClassName } = useScreenOrientationExtended();
  const detectMobile = useDeviceSizeDetect();
  return (
    <div className={classNames(['container-holder', orientationClassName], {
      "mobile": detectMobile.isMobile,
      "desktop": detectMobile.isDesktop,
      "is-configurator-available": isConfiguratorAvailable,
    })}>
      {children}
    </div>
  )
}

MainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
}